import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
// import classNames from 'classnames'

import { routes } from '../../constants/routes'

import '../../assets/scss/nav.scss'

const MainNav = ({ noBanner }) => {
    const [isExpanded, setIsExpanded] = useState(false)
    // const { index, features, madeForDealFlow, pricing, requestDemo, contact } = routes
    const { index, features, pricing, contact } = routes
    const onToggle = () => {
        setIsExpanded(!isExpanded)
    }

    // const onNavigate = () => {
    //     setIsExpanded(false)
    // }

    // let classes = classNames({
    //     expanded: this.state.isExpanded,
    //     darken: this.props.noBanner
    // })
    return (
        <div id="main-nav" className={`${isExpanded ? 'expanded' : ''} ${noBanner ? 'darken' : ''}`}>
            <div className="brand">
                <Link to={index}>
                    { noBanner ?
                        <img src="/img/brand/visprop-logo-blue.svg" alt="VisProp Occupier Logo" /> :
                        <img src="/img/brand/visprop-logo-white.svg" alt="VisProp Occupier Logo" />
                    }
                </Link>
            </div>
            <div className="navbar-toggle bars" onClick={onToggle} aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="top" />
                <span className="middle" />
                <span className="bottom" />
            </div>
            <div className="links-wrapper">
                <div className="page-links">
                    <NavLink to={features}>
                        Features
                    </NavLink>
                    {/* <NavLink to={madeForDealFlow}>
                        Customers
                    </NavLink> */}
                    <NavLink to={pricing}>
                        Pricing
                    </NavLink>
                    {/* <Link to={requestDemo}>
                        Request Demo
                    </Link> */}
                </div>
                <div className="auth-links">
                    <NavLink to={contact}>
                        Contact
                    </NavLink>
                    <a href="https://dashboard.vispropanalytics.com/login/">
                        Login
                    </a>
                    <a href="https://dashboard.vispropanalytics.com/register/" className="btn">
                        Free Trial
                    </a>
                </div>
            </div>
        </div>
    )
}

export default MainNav

